import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'
import { hasActualValue } from '@core/utils/form-utils'

export const TITLED_ENGINE_SERIAL_NUMBER_MIN_LENGTH = 2
export const TITLED_ENGINE_SERIAL_NUMBER_MAX_LENGTH = 8
export const TITLED_ENGINE_SERIAL_NUMBER_MAX_HYPHENS = 1

const ALLOWED_CHARACTERS = /^[A-Za-z0-9-]+$/

/**
 * Validates the format of a titled engine serial number: digits and letters only,
 * at most one hyphen, and between 2 and 8 characters in total.
 *
 * An empty value is considered valid — the field is optional, so a missing value is
 * covered by `Validators.required` where it is needed.
 */
export function titledEngineSerialNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string | null
    if (!hasActualValue(value)) {
      return null
    }

    const serialNumber = value.trim()
    const hyphenCount = serialNumber.split('-').length - 1
    const isValid = ALLOWED_CHARACTERS.test(serialNumber)
      && hyphenCount <= TITLED_ENGINE_SERIAL_NUMBER_MAX_HYPHENS
      && serialNumber.length >= TITLED_ENGINE_SERIAL_NUMBER_MIN_LENGTH
      && serialNumber.length <= TITLED_ENGINE_SERIAL_NUMBER_MAX_LENGTH

    return isValid ? null : { titledEngineSerialNumberFormat: true }
  }
}
